import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_zveycrc8ge: FaireCollectionEntity = {
  token: "pbc_zveycrc8ge",
  type: "collection",
  name: "Activewear ⚽🎾",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bd4fdce19cd54f2e99cdf348be31892ae3f5f03552901f6ef8f00449be47396e.jpeg",
  itemCount: 12,
  description:
    "Sweet, sporty, and made to move! Our new activewear collection blends playful prints with comfy fits for all-day adventures, from playground fun to after-school twirls. Designed for little movers who like their style as cute as it is comfy.",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:39.348Z",
    importedBy: "entity-db-import-collections",
  },
};
